import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is DevOps, and how does it differ from traditional software development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>DevOps is a set of practices that aims to improve the collaboration and communication between development and operations teams to deliver software more quickly and reliably. DevOps differs from traditional software development in that it emphasizes a culture of collaboration and integration rather than a siloed approach to development and operations. It involves automation and continuous integration and delivery (CI/CD) to streamline the development and deployment process.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What services does TekRevol offer in the field of DevOps consultancy?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol offers various DevOps consultancy services, including assessment and planning, implementation and deployment, and ongoing support and maintenance. Our team of experts can help you understand the potential benefits of DevOps for your organization and develop a customized strategy to implement and optimize DevOps practices.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    How much does DevOps consultancy cost, and what factors impact the price?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The cost of DevOps consultancy varies depending on the scope and complexity of the project. Some factors that can impact the price include the size of your organization, the complexity of your IT environment, and the extent of the work required to implement and optimize DevOps practices. We offer competitive pricing and work with clients to identify cost-saving opportunities wherever possible. Contact us to discuss your specific needs and receive a customized quote.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;